import { render, staticRenderFns } from "./PaymentLink.vue?vue&type=template&id=069b656e&"
import script from "./PaymentLink.vue?vue&type=script&lang=js&"
export * from "./PaymentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PaymentLink.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('069b656e')) {
      api.createRecord('069b656e', component.options)
    } else {
      api.reload('069b656e', component.options)
    }
    module.hot.accept("./PaymentLink.vue?vue&type=template&id=069b656e&", function () {
      api.rerender('069b656e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/steps/PaymentLink.vue"
export default component.exports